import accountSafe from './pt/account-safe'
import affiliate from './pt/affiliate'
import bankTransfer from './pt/bankTransfer'
import cart from './pt/cart'
import cartAndWarehouse from './pt/cartAndWarehouse'
import common from './pt/common'
import consult from './pt/consult'
import debt from './pt/debt'
import distribution from './pt/distribution'
import emailSend from './pt/emailSend'
import estimation from './pt/estimation'
import form from './pt/form'
import home from './pt/home'
import kol from './pt/kol'
import order from './pt/order'
import orderDetail from './pt/orderDetail'
import packages from './pt/package'
import pay from './pt/pay'
import pecenter from './pt/pecenter'
import points from './pt/points'
import previewPackage from './pt/previewPackage.json'
import previewPackageOptimize from './pt/previewPackageOptimize'
import product from './pt/product'
import returnChange from './pt/returnChange'
import search from './pt/search'
import shareCoupon from './pt/shareCoupon'
import sharePackage from './pt/sharePackage'
import shoppingGuide from './pt/shoppingGuide'
import site from './pt/site'
import status from './pt/status'
import storage from './pt/storage'
import tag from './pt/tag'
import tips from './pt/tips'
import transport from './pt/transport'
import uniOrder from './pt/uniOrder'
import vip from './pt/vip'
import warnTips from './pt/warnTips'
export default {
  'account-safe': accountSafe,
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  distribution,
  uniOrder,
  bankTransfer,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
  vip,
  emailSend,
}
